import React from 'react';

// swaycross.com ルートの簡易ランディング (2026-09-01)。
// Google OAuth 検証が「アプリのホームページにプライバシーポリシーへのリンクがあること」を
// 要求するため、404 ではなく Sway の紹介 + フッターリンクを返す。

const LandingPage = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#11181C',
        color: '#fff',
        padding: '20px',
        textAlign: 'center',
      }}
    >
      <h1 style={{ fontSize: '56px', margin: 0, fontWeight: 700 }}>Sway</h1>
      <p style={{ fontSize: '18px', margin: '16px 0 8px', fontWeight: 600 }}>
        音楽でつながる位置情報SNS
      </p>
      <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.6)', marginBottom: '32px' }}>
        すれ違った人の聴いている曲が、マップに残る。
      </p>
      <a
        href="https://apps.apple.com/jp/app/id6738626019"
        style={{
          display: 'inline-block',
          backgroundColor: '#fff',
          color: '#11181C',
          fontWeight: 700,
          fontSize: '15px',
          padding: '12px 28px',
          borderRadius: '24px',
          textDecoration: 'none',
        }}
      >
        App Store でダウンロード
      </a>
      <footer style={{ marginTop: '64px', fontSize: '13px', color: 'rgba(255,255,255,0.55)' }}>
        <a href="/privacy" style={{ color: 'rgba(255,255,255,0.75)', margin: '0 10px' }}>
          プライバシーポリシー
        </a>
        <a
          href="https://tell-path.com/"
          target="_blank"
          rel="noreferrer"
          style={{ color: 'rgba(255,255,255,0.75)', margin: '0 10px' }}
        >
          運営会社
        </a>
      </footer>
    </div>
  );
};

export default LandingPage;
